import moment from 'moment'

type RangeValue = { start: number | ''; end: number | '' }

export type CowsFilterStats = {
	age: RangeValue
	lactation: RangeValue
	lastMilking: RangeValue
	lastLamenessMeasurement: RangeValue
	fatness: RangeValue
	limpnessDays: RangeValue
}

const getMinMax = (values: number[]): RangeValue => {
	const filteredValues = values.filter(value => Number.isFinite(value))
	if (filteredValues.length === 0) return { start: '', end: '' }

	return {
		start: Math.min(...filteredValues),
		end: Math.max(...filteredValues),
	}
}

type CowStatsSource = {
	birth_date?: string | number | null
	lactation_length?: number | string | null
	limpness_change_dt?: number | string | null
	fatness?: number | string | null
	limpness_start_dt?: string | number | null
}

export const getCowsFilterStats = (cows: CowStatsSource[]): CowsFilterStats => {
	const now = moment()
	const ageValues = cows
		.filter(cow => cow.birth_date)
		.map(cow =>
			Number(now.diff(moment(cow.birth_date), 'years', true).toFixed(1)),
		)
	const lactationValues = cows
		.filter(cow => Number(cow.lactation_length) > 0)
		.map(cow => Number(cow.lactation_length))
	const lastLamenessMeasurementValues = cows
		.filter(cow => cow.limpness_change_dt)
		.map(cow => Number(cow.limpness_change_dt))
	const fatnessValues = cows
		.filter(cow => cow.fatness != null)
		.map(cow => Number(cow.fatness))
	const limpnessDaysValues = cows
		.filter(cow => cow.limpness_start_dt)
		.map(cow => Math.max(0, now.diff(moment(cow.limpness_start_dt), 'days')))

	return {
		age: getMinMax(ageValues),
		lactation: getMinMax(lactationValues),
		lastMilking: { start: '', end: '' },
		lastLamenessMeasurement: getMinMax(lastLamenessMeasurementValues),
		fatness: getMinMax(fatnessValues),
		limpnessDays: getMinMax(limpnessDaysValues),
	}
}
